import { render } from "./YellowDivider.vue?vue&type=template&id=3a0e1d9e"
import script from "./YellowDivider.vue?vue&type=script&lang=js"
export * from "./YellowDivider.vue?vue&type=script&lang=js"

import "./YellowDivider.vue?vue&type=style&index=0&id=3a0e1d9e&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__